import { ISalesOrderInput, ISalesOrderLineInput } from '../../../graphql/schema/p4types';

export const submitSalesOrderValues = (
  { values }: { values: ISalesOrderInput },
  isTemporary: boolean,
  supportingData?: any
) => {
  const header: any = Object.assign({}, values);
  delete header.headOffice;

  if (!isTemporary) {
    header.orderLines =
      header.orderLines?.filter?.(
        (line: ISalesOrderLineInput) => !!line.product && !line.product?.template && (line.id || !line.deleted)
      ) || [];
    header.tradeCounterOrder = false;
    //Set 'generatedPurchaseOrder' values from form supportingData.
    //This structure is to avoid needing to pass a whole PO/line to/from the services on every temporary save.
    header.orderLines.forEach((orderLine: ISalesOrderLineInput) => {
      if (supportingData?.salesLineNewPurchaseOrderMap?.[orderLine.uuid!]) {
        orderLine.generatedPurchaseOrder = supportingData.salesLineNewPurchaseOrderMap[orderLine.uuid!];
      }
    });
  }

  return header as ISalesOrderInput;
};
